module.exports = __webpack_public_path__ + "img/Orbiting-4.08f70f4c.png";